import styled from 'styled-components';

const ErrorPanel = styled.div`
    z-index: 1;
    pointer-events: none;
    background-color: transparent;
    justify-self: center;
    padding: 1rem;
    grid-column: controls-end / page-end;
    grid-row: error-bar-top / error-bar-bottom;

    /* Allow pointer events only on child elements */
    & > * {
        pointer-events: all;
    }
`;

export default ErrorPanel;
